/**
 * Bold Theme Configuration
 *
 * Eye-catching, modern, memorable design with vibrant accents.
 * Best for: Marketing sites, consumer apps, creative portfolios
 */

import type { ThemeConfig } from '#src/errors/types';

export const boldTheme: ThemeConfig = {
  iconSize: 'h-14 w-14',
  badgeStyle: 'rounded-full border-2 border-primary/20 bg-primary/10 px-5 py-2 shadow-md',
  headingSize: 'text-4xl font-extrabold sm:text-6xl',
  animation: true
} as const;
